<footer class="bg-bar-deep mt-auto py-8.5">
	<div class="wrap flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
		<span class="text-on-bar-soft text-[13px]">© {new Date().getFullYear()} mrt-radar.de</span>
		<div class="flex flex-wrap gap-x-5 gap-y-2">
			<a
				href="/datenschutz"
				class="text-on-bar-soft hover:text-on-bar text-[13.5px] transition-colors duration-200"
				>Datenschutz</a
			>
			<a
				href="/impressum"
				class="text-on-bar-soft hover:text-on-bar text-[13.5px] transition-colors duration-200"
				>Impressum</a
			>
			<a
				href="/kontakt"
				class="text-on-bar-soft hover:text-on-bar text-[13.5px] transition-colors duration-200"
				>Hilfe & Kontakt</a
			>
		</div>
	</div>
</footer>
